<template>
  <v-data-table
    :headers="headers"
    :value="selected"
    @input="
      $emit(
        'input',
        $event.map((i) => i.id)
      )
    "
    hide-default-footer
    :loading="loading"
    :items="items"
    :items-per-page="-1"
    sort-by="number"
    sort-desc=""
    item-key="id"
    show-select
  >
    <template v-slot:item.number="{ item }">
      {{ item.number }}
      <div
        class="mt-n1 text--disabled"
        v-if="item.group && item.payee.code !== 'schoolFund'"
      >
        {{ item.group.number }}
      </div>
    </template>
    <template v-slot:item.date="{ item }">
      <DateValue :value="item.date" />
    </template>
    <template v-slot:item.employee="{ item }">
      <PersonChip codeOnly :value="item.employee" />
    </template>
    <template v-slot:item.status="{ item }">
      <v-tooltip top v-if="item.status.code == 'rejected'">
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs" v-on="on">mdi-alert</v-icon>
        </template>
        <span>{{ item.status.description }} </span>
      </v-tooltip>
      <v-tooltip top v-if="item.department">
        <template v-slot:activator="{ on, attrs }">
          <v-chip small v-bind="attrs" v-on="on">{{ item.department }}</v-chip>
        </template>
        <span>Sammelrechnung FS {{ item.department }} </span>
      </v-tooltip>
    </template>
    <template v-slot:item.payee="{ item }">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            v-bind="attrs"
            v-on="on"
            v-if="item.payee.code == 'schoolFund'"
            >mdi-printer</v-icon
          >
          <v-icon
            v-bind="attrs"
            v-on="on"
            v-else-if="item.payee.code == 'original'"
            >mdi-credit-card</v-icon
          >
          <v-icon
            v-bind="attrs"
            v-on="on"
            v-else-if="item.payee.code == 'employee'"
            >mdi-account</v-icon
          >
        </template>
        <span>{{ item.payee.description }} </span>
      </v-tooltip>
    </template>
    <template v-slot:item.amount="{ item }">
      <CurrencyValue v-if="item.amount" :value="item.amount" />
      <span v-else>?</span>
    </template>
    <template v-slot:item.amountForeign="{ item }">
      <CurrencyValue
        v-if="!item.currency.local"
        :currency="item.currency.code"
        :value="item.currency.local ? item.amount : item.amountForeign"
      />
      <span v-else>–</span>
    </template>
    <template v-slot:footer
      ><TableFooter
        :items="items"
        label="Rechnungen"
        labelSingular="Rechnung"
      ></TableFooter
    ></template>
  </v-data-table>
</template>
<script>
import { defineComponent } from "vue";
import CurrencyValue from "common/components/CurrencyValue.vue";
import DateValue from "common/components/DateValue.vue";
import PersonChip from "common/components/PersonChip.vue";
import TableFooter from "common/components/TableFooter.vue";

export default defineComponent({
  components: { CurrencyValue, DateValue, PersonChip, TableFooter },
  props: {
    page: { type: String, default: "InvoicePending" },
    items: { type: Array },
    selected: { type: Array },
  },
  data() {
    return {
      headers: [
        { text: "Nummer", value: "number" },
        { text: "Datum", value: "date" },
        { text: "Mitarbeiter", value: "employee" },
        { text: "Zahlung", value: "payee" },
        { text: "Anlass", value: "event" },
        { text: "Beschreibung", value: "description" },
        { text: "Fremdwährung", value: "amountForeign", align: "right" },
        { text: "Betrag", value: "amount", align: "right" },
      ],

      loading: false,
    };
  },
});
</script>
